import { QuizType } from './EditorStatus'

export const PREPARE = 0
export const QUESTION = 1
export const START = 2
export const TIMEOUT = 3
export const ANSWER_COUNT = 4
export const DEMONSTORATION = 4
export const IS_ANSWER = 5
export const RESULT = 6

export const FLOW_LIST = ['問表紙', '問題表示', '回答受付', '受付終了', '集計結果', '正解は？', '正解発表']
export const FLOW_LIST_REALTIME = ['表紙', '問題文', '回答受付', '受付終了', '実演', '正解は？', '正解発表']

export const nextPhase = (index, phase, questionCount) => {
  // questionCountを超えるindexの場合はrankingに遷移する
  if (index >= questionCount - 1 && phase === RESULT) {
    return { newType: QuizType.RANKING.value, newIndex: 0, newPhase: PREPARE }
  }

  switch (phase) {
    case PREPARE:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: QUESTION }
    case QUESTION:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: START }
    case START:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: TIMEOUT }
    case TIMEOUT:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: ANSWER_COUNT }
    case ANSWER_COUNT:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: IS_ANSWER }
    case IS_ANSWER:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: RESULT }
    case RESULT:
      return { newType: QuizType.QUESTION.value, newIndex: index + 1, newPhase: PREPARE }
  }
}

export const backPhase = (index, phase) => {
  if (index === 0 && phase === PREPARE) {
    return { newType: QuizType.FIRSTPAGE.value, newIndex: 0, newPhase: 0 }
  }

  switch (phase) {
    case PREPARE:
      return { newType: QuizType.QUESTION.value, newIndex: index - 1, newPhase: RESULT }
    case QUESTION:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: PREPARE }
    case START:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: QUESTION }
    case TIMEOUT:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: START }
    case ANSWER_COUNT:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: TIMEOUT }
    case IS_ANSWER:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: ANSWER_COUNT }
    case RESULT:
      return { newType: QuizType.QUESTION.value, newIndex: index, newPhase: IS_ANSWER }
  }
}
